var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorToDoorDisabled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 188,
    viewBox: "0 0 299 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 188,
    fill: "#F9F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.381 15.8682H200.381C216.458 15.8682 229.492 28.7282 229.492 44.5919V125.901H171.27V44.5919C171.27 28.7282 184.303 15.8682 200.381 15.8682Z",
    fill: "#E2E2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 28.2129H200.867C205.818 28.2129 210.566 30.1534 214.067 33.6076C217.568 37.0618 219.535 41.7466 219.535 46.6316V58.9791H182.2V46.6316C182.2 41.7466 184.167 37.0618 187.668 33.6076C191.168 30.1534 195.916 28.2129 200.867 28.2129Z",
    fill: "#4F5B94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.887 72.2785C217.407 72.2785 218.64 71.0623 218.64 69.5621C218.64 68.0619 217.407 66.8457 215.887 66.8457C214.366 66.8457 213.134 68.0619 213.134 69.5621C213.134 71.0623 214.366 72.2785 215.887 72.2785Z",
    fill: "#4F5B94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.2 58.9791V46.6316C182.2 36.4592 190.558 28.2129 200.867 28.2129",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.27 44.5919C171.27 28.7282 184.303 15.8682 200.381 15.8682",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.866 26.1372V62.4212",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.254 44.2795H182.48",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.711 183.555H153.387L182.266 120.506H228.711V183.555Z",
    fill: "#273754",
    stroke: "#273754"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122.23,
    y: 174.548,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130.432,
    y: 165.541,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 138.635,
    y: 156.534,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146.837,
    y: 147.527,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 155.04,
    y: 138.52,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163.242,
    y: 129.513,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 171.445,
    y: 120.506,
    width: 49.1246,
    height: 9.00698,
    fill: "#F9F9FF",
    stroke: "#273754"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.23 174.548H171.355V183.555H122.23",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M130.432 165.541H179.556V174.548H130.432",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M138.635 156.534H187.759V165.541H138.635",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.837 147.527H195.961V156.534H146.837",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.04 138.52H204.165V147.527H155.04",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.242 129.513H212.367V138.52",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.445 120.506H220.57V129.513H171.445",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.315 183.555H231.626",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.158 180.48C129.044 150.12 115.317 93.1353 115.317 93.1353L96.5684 80.3506V139.903L114.232 184.455H130.762L128.158 180.48Z",
    fill: "#4F5B94"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.317 140.033C115.317 117.38 108.504 99.0156 100.101 99.0156C98.8384 99.0369 97.6103 99.424 96.5684 100.129V139.903L109.45 172.394C113.021 164.888 115.317 153.184 115.317 140.033Z",
    fill: "#273754"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.748 86.5621C109.748 86.5621 113.721 150.688 102.501 181.05L104.844 184.455H84.8882C84.8882 184.455 82.708 102.89 82.708 85.2856L109.748 86.5621Z",
    fill: "#4F5B94"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.392 36.9477V45.2815L93.9531 47.8189V33.7551L104.392 31.2178V36.9477Z",
    fill: "#E2E2FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6582 39.7686C98.9343 39.7686 99.1582 39.5447 99.1582 39.2686C99.1582 38.9924 98.9343 38.7686 98.6582 38.7686C98.3821 38.7686 98.1582 38.9924 98.1582 39.2686C98.1582 39.5447 98.3821 39.7686 98.6582 39.7686Z",
    fill: "#273754"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.947 39.7686C103.223 39.7686 103.447 39.5447 103.447 39.2686C103.447 38.9924 103.223 38.7686 102.947 38.7686C102.671 38.7686 102.447 38.9924 102.447 39.2686C102.447 39.5447 102.671 39.7686 102.947 39.7686Z",
    fill: "#273754"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.523 41.2012V36.9473H103.678",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9688 36.9469H100.124",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6396 39.1265V40.6038C93.8338 40.6038 93.1807 39.9578 93.1807 39.1609C93.1807 39.1167 93.1827 39.0729 93.1866 39.0296C93.2684 38.1336 94.6396 38.2269 94.6396 39.1265Z",
    fill: "#E2E2FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6396 40.604C93.8338 40.604 93.1807 39.958 93.1807 39.1611",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.038 44.4965C99.6465 44.4965 99.2709 44.3426 98.994 44.0688C98.7171 43.7949 98.5615 43.4234 98.5615 43.0361",
    stroke: "#4F5B94",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7971 47.6743L93.1807 48.3103",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M101.524 41.2041L100.582 41.4332",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0514 40.6039C95.0514 40.6039 94.1659 47.5407 99.4791 47.6704C104.792 47.8002 105.265 44.6796 105.028 40.291",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.436 38.5512C93.436 38.5512 91.4775 33.0089 94.2653 30.7383C97.0532 28.4676 105.745 30.4139 105.417 32.6521C105.089 34.8902 97.2499 35.0524 97.2499 35.0524C97.2499 35.0524 97.086 37.1933 95.9708 37.5501C95.9708 37.5501 95.8396 39.6497 96.2988 40.7894",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0264 62.7421V85.2861L115.318 93.1355V68.0277C115.318 59.1249 109.172 51.3724 100.431 49.2475H100.431C96.2385 48.2284 91.8054 49.1718 88.4081 51.806C85.0108 54.4402 83.0264 58.4727 83.0264 62.7421V62.7421Z",
    fill: "#E2E2FC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.11 74.5731L111.828 65L122 66.2138L117.481 81L108 79.767",
    fill: "#4F5B94"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.747 86.562C109.747 86.562 113.72 150.688 102.5 181.05",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6964 52.397C87.6964 52.397 71.4373 70.4173 74.8483 85.2858C78.2593 100.154 112.862 86.6264 113.665 80.3506C114.468 74.0747 108.302 78.0969 108.302 78.0969C108.302 78.0969 108.692 74.7397 107.511 76.0372C106.331 77.3347 105.436 78.3776 105.436 78.3776L91.5096 76.7995L94.9964 69.1442",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M120.067 64.813C116.82 66.4009 116.16 63.8089 116.16 63.8089C115.599 64.0035 113.816 65.9674 114.016 63.8089C114.105 62.576 114.96 61.5281 116.16 61.1815C116.16 61.1815 124.691 59.0609 125.38 69.3172C126.069 79.5735 121.144 86.1227 116.16 84.3418",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107 52C110.683 54.6399 111.5 56 114 60",
    stroke: "#273754",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 184.5,
    x2: 277.5,
    y2: 184.5,
    stroke: "#1D2943",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorToDoorDisabled);
export default __webpack_public_path__ + "static/media/door-to-door-disabled.5b9fcd7e95bc780fa83e0dfc7a04064c.svg";
export { ForwardRef as ReactComponent };